import React from "react";
import { motion } from "framer-motion";

const services = [
  {
    icon: "/assets/img/Industrial.jpg",
    title: "Application Development and Maintenance Services",
    description:
      "Tailored software solutions designed to meet specific business needs and enhance operational efficiency.",
  },
  {
    icon: "/assets/img/Industrial.jpg",
    title: "Web Development and Design",
    description:
      "Creating and structuring websites for functionality and aesthetics using coding languages and design principles.",
  },
  {
    icon: "/assets/img/Industrial.jpg",
    title: "Cloud Solutions",
    description:
      "Scalable, on-demand computing services, storage, and resources accessible over the internet for efficient operations.",
  },
  {
    icon: "/assets/img/Industrial.jpg",
    title: "Cybersecurity",
    description:
      "Protecting digital systems from unauthorized access, attacks, and ensuring data confidentiality and integrity.",
  },
  {
    icon: "/assets/img/Industrial.jpg",
    title: "Mobile App Development",
    description:
      "Creating software applications for mobile devices to meet user needs and enhance digital experiences.",
  },
  {
    icon: "/assets/img/Industrial.jpg",
    title: "Data Analytics",
    description:
      "Extracting insights from data to inform decision-making and drive business improvements.",
  },
  {
    icon: "/assets/img/Industrial.jpg",
    title: "IT Consulting",
    description:
      "Advising businesses on technology strategies, solutions, and optimization for efficiency and growth.",
  },
  {
    icon: "/assets/img/Industrial.jpg",
    title: "UI-UX Design",
    description:
      "Enhancing user satisfaction by improving usability, accessibility, and overall interaction aesthetics.",
  },
];

const FocusArea = () => {
  return (
    <div className="py-16 px-4 sm:px-6 lg:px-12 bg-white">
      <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12">
        SERVICES <span className="text-blue-600">WE OFFER</span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10 max-w-6xl mx-auto">
        {services.map((service, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            viewport={{ once: true }}
            whileHover={{ scale: 1.02 }}
            className="flex items-start space-x-6 p-4 rounded-md hover:shadow-lg transition-shadow duration-300 cursor-pointer"
          >
            <div className="min-w-[60px] transform transition-transform duration-300 group-hover:scale-105">
              <motion.img
                src={service.icon}
                alt={service.title}
                className="w-14 h-14 object-cover bg-gray-100 rounded p-2 shadow-md"
                whileHover={{ rotate: 5 }}
                transition={{ type: "spring", stiffness: 300 }}
              />
            </div>
            <div>
              <h4 className="text-lg font-semibold text-gray-800 mb-1">
                {service.title}
              </h4>
              <p className="text-gray-600 text-sm">{service.description}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default FocusArea;
